

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { FileData } from '@/types/asset';
import FileInputNormalizer from '@/classes/normalizers/field-normalizers/FileInputNormalizer';

@Component
export default class PreviewMediaField extends Vue {
  fileData: FileData|null = null;

  normalizer = new FileInputNormalizer();

  @Prop()
  readonly label!: string;

  @Prop()
  readonly value!: any;

  async beforeMount() {
    if (this.value) {
      this.fileData = await this.normalizer.normalize(this.value.id);
    }
  }
}
